<template>
  <div :style="{ height: height }" class="sellCenter">
    <div class="inputWrap">
      <div class="header" ref="header">
        <div></div>
        <div>
          <el-button type="info" size="mini" @click="onSubmit"
            >发布求购</el-button
          >
        </div>
      </div>

      <div
        :style="{ height: formHeight + 'px', backgroundColor: '#fff' }"
        class="formBox"
      >
        <el-form ref="form" :model="form" size="mini" label-width="150px">
          <div class="formInfo">
            <el-alert
              v-show="showErr.show"
              :title="showErr.text"
              type="warning"
              :closable="false"
              show-icon
            >
            </el-alert>
          </div>
          <div class="formInnerBox" :style="{ height: formHeight - 40 + 'px' }">
            <el-form-item class="forItem" label="商品名称">
              <el-input
                placeholder="建议：品牌+商品名+属性"
                v-model="form.s_name"
              ></el-input>
            </el-form-item>

            <el-form-item label="产品分类">
              <el-cascader
                v-model="form.types"
                :options="myAllTypes"
                @change="allTypeChange"
              ></el-cascader>
            </el-form-item>

            <!-- <el-form-item label="等级">
              <el-select v-model="form.grade" placeholder="请选择计价">
                <el-option
                  :key="index"
                  v-for="(item, index) in gradeData"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item> -->

            <el-form-item label="计价单位">
              <el-select v-model="form.unit" placeholder="请选择计价">
                <el-option
                  :key="index"
                  v-for="(item, index) in unitData"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="购买单位">
              <el-select v-model="form.buyUnit" placeholder="请选择购买单位">
                <el-option
                  :key="index"
                  v-for="(item, index) in unitData"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item class="forItem" label="购买价格">
              <el-input placeholder="空默认为随行就市" v-model="form.price">
                <template slot="append">{{ `元/${form.unit}` }}</template>
              </el-input>
            </el-form-item>

            <el-form-item class="forItem" label="定金">
              <el-input placeholder="请输入定金" v-model="form.orderPrice">
                <template slot="append">{{ `元/${form.buyUnit}` }}</template>
              </el-input>
            </el-form-item>

            <el-form-item class="forItem" label="需求数量">
              <el-input placeholder="请输入需求数量" v-model="form.sdNumber">
                <template slot="append">{{ `${form.buyUnit}` }}</template>
              </el-input>
            </el-form-item>

            <el-form-item label="购买地址">
              <el-cascader
                v-model="form.threeLevelAddrId"
                :options="citys"
              ></el-cascader>
            </el-form-item>

            <el-form-item class="forItem" label="详情地址">
              <el-input v-model="form.sdAddress"></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="form.sdStatus" placeholder="选择商品状态">
                <el-option label="不限" value="0"></el-option>
                <el-option label="现货" value="1"></el-option>
                <el-option label="期货" value="2"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="产地">
              <el-select v-model="form.birthPlace" placeholder="请选择产地">
                <el-option
                  :key="index"
                  v-for="(item, index) in internationCity3"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="forItem" label="采购日期">
              <el-date-picker
                type="date"
                placeholder="选择采购日期"
                v-model="form.sdDate"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
            <el-form-item class="forItem" label="信息有效期限">
              <el-date-picker
                type="date"
                placeholder="选择信息有效期限"
                v-model="form.endTime"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
            <el-form-item class="forItem" label="需求描述">
              <el-input
                type="textarea"
                rows="3"
                v-model="form.details"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";

import {
  queryStoreEmployee,
  queryAllClassCategry,
  gradeData,
  unitData,
  internationCity3,
  publishSupplyApi,
} from "@/api/api";

import citys from "@/utils/city.js";
export default {
  props: ["height"],
  data() {
    return {
      form: {
        s_name: "",
        types: null,
        goodsType: "",
        breed: "",
        grade: "",
        unit: "",
        buyUnit: "",
        price: "",
        orderPrice: "", //定金
        subscription: "",
        unitWeight: "",
        minBuyCount: "",
        birthPlace: "",
        sdNumber: "",
        threeLevelAddrId: "",
        sdAddress: "",
        sdStatus: "",
        sdDate: "",
        endTime: "",
        details: "",
      },

      userEmployeeData: [],
      myAllTypes: [],

      birthPlaceData: citys,

      updata_qualified: false,
      updata_qualified_size: false,

      upLoadImg: { show: false, src: "" },
      upLoadImg1: { show: false, src: "" },
      formHeight: "",
      showErr: {
        show: false,
        text: "",
      },
    };
  },
  created() {
    this.gradeData = gradeData;
    this.unitData = unitData;

    this.internationCity3 = internationCity3;
    this.citys = citys;

    this.initStoreEmployee();
    this.initMyTypes();

    console.log(this.userInfo);
    console.log(this.companyInfo);
  },

  mounted() {
    // this.setFormHeight();
    // window.addEventListener("resize", this.setFormHeight);
  },

  computed: {
    ...mapState(["userInfo", "companyInfo"]),
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    setFormHeight() {
      console.log("parseFloat(this.height)", parseFloat(this.height));
      console.log(
        "this.$refs.header.innerHeight",
        this.$refs.header.clientHeight
      );
      setTimeout(() => {
        this.formHeight =
          parseFloat(this.height) - this.$refs.header.clientHeight - 100;
      });
    },
    initMyTypes() {
      let that = this;
      let url = queryAllClassCategry;
      let { storeId } = this.userInfo;
      let data = {
        kind: 1,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          console.log(res);
          if (res.data.resultCode == 1) {
            const { data } = res.data;
            console.log(data);
            this.regroupMyTypes(data);
          }else{
            this.$alert(res.data.resultMsg)
          }
        })
        .catch((err) => {
          this.$alert(JSON.stringify(err))
        });
    },
    regroupMyTypes(data) {
      this.myAllTypes = data.map((item, index) => {
        item.label = item.typeName;
        item.value = item.typeId;
        item.tlist &&
          item.tlist.map((subItem, index) => {
            subItem.label = subItem.typeName;
            subItem.value = subItem.typeId;

            subItem.tlist &&
              subItem.tlist.map((thItem, index) => {
                thItem.label = thItem.typeName;
                thItem.value = thItem.typeId;
                console.log(thItem.tlist);
                thItem.children = thItem.tlist;
                return thItem;
              });
            console.log(subItem.tlist);
            subItem.children =
              subItem.tlist.length > 0
                ? subItem.tlist
                : [{ value: "", label: "无" }];
            return subItem;
          });

        item.children = item.tlist;
        return item;
      });
      console.log(this.myAllTypes);
    },
    allTypeChange(types) {
      console.log(types);
      console.log(this.myAllTypes);
      let goodsType = "",
        breed = [];

      this.myAllTypes &&
        this.myAllTypes.forEach((item, index) => {
          if (item.typeId == types[0]) {
            console.log(item.label);
            goodsType = item.label;
            breed.push(item.label);
            item.tlist.forEach((subItem, index) => {
              if (subItem.typeId == types[1]) {
                console.log(subItem.label);
                breed.push(subItem.label);
                subItem.tlist &&
                  subItem.tlist.forEach((thItem, index) => {
                    if (thItem.typeId == types[2]) {
                      console.log(thItem.label);
                      breed.push(thItem.label);
                    }
                  });
              }
            });
          }
        });
      console.log(goodsType, breed);
      let form1 = JSON.parse(JSON.stringify(this.form));
      console.log(form1);
      form1.goodsType = goodsType;
      form1.breed = breed.join(",");
      console.log(1111);
      console.log(form1);

      this.form = form1;
      console.log(222);
      console.log(this.form);
    },

    commoditySourceChange(val) {
      this.form.birthPlace = "";
      this.birthPlaceData = val == 2 ? internationCity : citys;
    },
    onSubmit() {
      if (true) {
        let {
          s_name,
          types,
          goodsType,
          breed,
          grade,
          unit,
          buyUnit,
          price,
          orderPrice,
          subscription,
          unitWeight,
          minBuyCount,
          birthPlace,
          sdNumber,
          threeLevelAddrId,
          sdAddress,
          sdStatus,
          sdDate,
          endTime,
          details,
        } = this.form;

        if (!s_name) {
          this.showErr = {
            show: true,
            text: "请填写商品名称",
          };
          return;
        }
        if (!types) {
          this.showErr = {
            show: true,
            text: "请选择产品分类",
          };
          return;
        }

        if (!unit) {
          this.showErr = {
            show: true,
            text: "请选择计价单位",
          };
          return;
        }
        if (!buyUnit) {
          this.showErr = {
            show: true,
            text: "请选择购买单位",
          };
          return;
        }


        if (!sdNumber) {
          this.showErr = {
            show: true,
            text: "请输入需求数量",
          };
          return;
        }

        if (!threeLevelAddrId) {
          this.showErr = {
            show: true,
            text: "请选择购买地址",
          };
          return;
        }
        if (!sdAddress) {
          this.showErr = {
            show: true,
            text: "请输入详情地址",
          };
          return;
        }
        if (sdStatus === "") {
          this.showErr = {
            show: true,
            text: "请选择商品状态",
          };
          return;
        }

        if (!sdDate) {
          this.showErr = {
            show: true,
            text: "请选择采购日期",
          };
          return;
        }

        if (!endTime) {
          this.showErr = {
            show: true,
            text: "请选择信息有效日期",
          };
          return;
        }

        this.showErr = {
          show: false,
          text: "",
        };

        let { access_token } = this.userInfo;
        let subData = {
          access_token,
          birthPlace,
          breed,
          buyUnit,
          details,
          endTime: new Date(endTime).getTime(),
          goodsType,
          orderPrice,
          price,
          sdAddress,
          sdAreaId: threeLevelAddrId[2],
          sdDate: new Date(sdDate).getTime(),
          sdName: s_name,
          sdNumber,
          sdStatus,
          sdType: 2,
          types: types.join(),
          unit,
        };
        console.log("subData", subData);
        // return
        let that = this;
        let url = publishSupplyApi;
        let data = subData;
        let param = new URLSearchParams();
        for (var k in data) {
          param.append(k, data[k]);
        }
        this.$axios({
          method: "post",
          data: param,
          url,
        })
          .then((res) => {
            console.log(res);
            if (res.data.resultCode == 1) {
              const { data } = res.data;
              this.$alert("信息发布成功", {
                center: true,
                showClose: true,
                callback: (action) => {
                  this.$router.go(-1);
                },
              });
            } else {
              this.$alert(res.data.resultMsg);
            }
          })
          .catch((err) => {
            this.$alert(JSON.stringify(err));
          });
      }
    },
    testAddAddres(form) {
      let flag = true;
      for (var k in form) {
        let { value, reg, warning } = form[k];
        if (reg) {
          let showTips = [];
          reg.forEach((item) => {
            if (!item.rule.test(value)) {
              form[k].warning = item.info;
              flag = false;
              showTips.push(true);
            } else {
              showTips.push(false);
            }
          });
          console.log(showTips);
          showTips.every((item) => item == false) && (form[k].warning = "");
        }
      }
      return flag;
    },
    initStoreEmployee() {
      let that = this;
      let url = queryStoreEmployee;
      let { storeId } = this.userInfo;
      let data = {
        storeId,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          console.log(res);
          if (res.data.resultCode == 1) {
            const { data } = res.data;
            this.userEmployeeData = data;
          }else{
            this.$alert(res.data.resultMsg)
          }
        })
        .catch((err) => {
          this.$alert(JSON.stringify(err))
        });
    },
  },
};
</script>
<style scoped lang="less">
.sellCenter {
  overflow: hidden;
}
.warning {
  color: #f40;
  margin-left: 10px;
}
.inputWrap {
  margin: 10px;
}
.formBox {
  padding-left: 20px;
}
.forItem {
  width: 336px;
}
.formInnerBox {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: flex-start;
  max-width: 550px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.formInfo {
  width: 300px;
  height: 30px;
  margin-bottom: 20px;
  margin-left: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/SellCenter/components/PublishDemand.vue